import React, { Fragment } from "react";

import AreaTriangulo from "../ejercicios/Lineales/AreaTriangulo";
import CaracteristicasNum from "../ejercicios/Lineales/CaracteristicasNum";
import NumCincoCifras from "../ejercicios/Lineales/NumCincoCifras";

const Lineales = () => {
  return (
    <Fragment>
      <AreaTriangulo />
      <CaracteristicasNum />
      <NumCincoCifras />
    </Fragment>
  );
};

export default Lineales;
